module.exports = __webpack_public_path__ + "img/mercedes-banner-top.889d9203.jpg";